import React, { useEffect, useMemo, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { isArray } from 'lodash';
import { FaEdit } from 'react-icons/fa';
import { MdOutlineDelete, MdInfoOutline } from 'react-icons/md';
import { getAllData } from '../../../redux/actions/api/GetAllData';
import { deleteData } from '../../../redux/actions/api/DeleteData';
import ModalConfirm from '../../../components/modal/ModalConfirm';
import Breadcrumb from '../../../components/breadcrumb/Breadcrumb';
import Loading from '../../../components/loading/Loading';
import Table from '../../../components/table/Table';

export default function Virtual() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { categoryId } = useParams();
  const location = useLocation();
  const { accessToken } = useSelector((state) => state.auth);
  const { data: all, loading, error } = useSelector((state) => state.api);
  const [courseId, setCourseId] = useState();
  const [showModalConfirm, setShowModalConfirm] = useState(false);
  const [isShowLoading, setIsShowLoading] = useState(false);
  const { virtual_courses: virtual } = all;
  const title_en = location?.state;
  // ----------------------------------------------------------------------------------->
  const columns = React.useMemo(
    () => [
      {
        Header: 'Title En',
        disableFilters: true,
        accessor: 'title_en',
      },
      {
        Header: 'Title Ar',
        disableFilters: true,
        accessor: 'title_ar',
      },
      {
        Header: 'Hours',
        disableFilters: true,
        accessor: 'hours',
      },
      {
        Header: 'Fees',
        disableFilters: true,
        accessor: 'fees',
      },
      {
        Header: 'Created At',
        disableFilters: true,
        accessor: 'created_at',
        Cell: ({ row }) => (
          <time>{moment(row.values.created_at).format('LLL')}</time>
        ),
      },
      {
        Header: 'Updated At',
        disableFilters: true,
        accessor: 'updated_at',
        Cell: ({ row }) => (
          <time>{moment(row.values.updated_at).format('LLL')}</time>
        ),
      },
      {
        Header: '',
        accessor: 'id',
        disableFilters: true,
        Cell: ({ row }) => (
          <>
            <button className='btn btn-icon btn-rounded btn-primary mr-1'>
              <FaEdit
                size='1rem'
                onClick={() =>
                  navigate(
                    `/categories/${categoryId}/virtual/${row.values.id}/edit`
                  )
                }
              />
            </button>
            <button className='btn btn-icon btn-rounded btn-danger mr-1'>
              <MdOutlineDelete
                size='1rem'
                onClick={() => {
                  setCourseId(row.values.id);
                  setShowModalConfirm(true);
                }}
              />
            </button>
            <button className='btn btn-icon btn-rounded btn-info'>
              <MdInfoOutline
                size='1rem'
                onClick={() =>
                  navigate(
                    `/categories/${categoryId}/virtual/${row.values.id}/details`,
                    {
                      state: row.original,
                    }
                  )
                }
              />
            </button>
          </>
        ),
      },
    ],
    [categoryId, navigate]
  );
  // ----------------------------------------------------------------------------------->
  useEffect(() => {
    dispatch(
      getAllData(`course-categories/${categoryId}/courses`, accessToken)
    );
  }, [accessToken, dispatch, categoryId, isShowLoading]);
  // ----------------------------------------------------------------------------------->
  const data = useMemo(() => isArray(virtual) && virtual, [virtual]);

  return (
    <>
      <ModalConfirm
        delete={() =>
          dispatch(
            deleteData(
              `virtual-courses/${courseId}`,
              accessToken,
              setShowModalConfirm,
              setIsShowLoading,
              isShowLoading
            )
          )
        }
        showModalConfirmTry={setShowModalConfirm}
        toggleModal={showModalConfirm}
      />
      <Breadcrumb
        className='px-3'
        url={`/categories/${categoryId}/virtual/new`}
        title={`All virtual courses by category ${title_en && title_en}`}
        textActive='Virtual'
        items={[{ title: 'Categories' }]}
        btnText='New'
      />
      {loading ? (
        <Loading isLoading={loading} />
      ) : error ? (
        error
      ) : (
        <div className='card shadow mb-4'>
          {data && <Table columns={columns} data={data ?? []} />}
        </div>
      )}
    </>
  );
}
